import * as React from 'react';
import { RefreshStepperButtons } from '../StepperButtons/RefreshStepperButtons';

interface instructions {
  title: string
  description: string
}
export interface WizardProps {
  actionComponents: React.ReactNode;
  nextStepText: string;
  previousText: string;
  nextStepDisabled?: boolean;
  nextStepLoading?: boolean;
  previousStepDisabled?: boolean;
  hideNavigation: boolean;
  instructions: instructions;
  key: string;
  title: string;
  footerInfoComponent?: React.ReactNode;
  onNext: () => void;
  onPrevious: () => void;
  oneStep: boolean;
  actionButtonText?: string;
  actionButtonDisabled?: boolean;
  actionButtonLoading?: boolean;
  onActionButton?: () => void;
  hideHeader?: boolean;
}

export const RefreshWizard: React.FC<Readonly<WizardProps>> = (props) => {
  return (
    <div key={props.key}>
      {props.actionComponents}
      <div>
        {!props.hideNavigation && (
          <div>
            <div className="absolute bottom-0 left-0 right-0 w-full border-t bg-grey-0 z-[99]">
              <RefreshStepperButtons
                nextStepText={props.nextStepText}
                nextStepDisabled={props.nextStepDisabled}
                nextStepLoading={props.nextStepLoading}
                onNext={props.onNext}
                previousStepDisabled={props.previousStepDisabled}
                previousText={props.previousText}
                onPrevious={props.onPrevious}
                actionButtonText={props.actionButtonText}
                actionButtonDisabled={props.actionButtonDisabled}
                actionButtonLoading={props.actionButtonLoading}
                onActionButton={props.onActionButton}
              />
            </div>
            <div>
              {props.footerInfoComponent}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

RefreshWizard.defaultProps = {
  nextStepDisabled: false,
  nextStepLoading: false,
  previousStepDisabled: false,
};
